import { Injectable, inject } from '@angular/core';
import { Page, ServiceHandler } from '@nucleus/ui-base';
import {
  NucleusMail,
  NucleusMailContent,
  NucleusMailFilter,
  NucleusMailServiceContract,
  NucleusMailStepResult,
} from '@nucleus/mail-report-ui';

import { MailService } from '../mail/mail.service';
import { FilterRequest } from '../filter-request';

/**
 * Bridges TaskSense's concrete MailService to the lib's
 * NucleusMailServiceContract. TaskSense's report methods expect a
 * `FilterRequest<NucleusMailFilter>` envelope — this adapter wraps
 * `(filter, page)` into that shape before delegating.
 */
@Injectable({ providedIn: 'root' })
export class TasksenseMailServiceAdapter implements NucleusMailServiceContract {
  private readonly delegate = inject(MailService);

  search(handler: ServiceHandler<NucleusMail[]>, _clientId?: string): void {
    this.delegate.search(handler as any);
  }

  filter(handler: any, filter: NucleusMailFilter, page?: Page, _clientId?: string): void {
    this.delegate.filter(handler, filter, page);
  }

  getMailTemplates(handler: ServiceHandler<string[]>): void {
    this.delegate.getMailTemplates(handler);
  }

  getMailContent(emailRequestId: string, handler: ServiceHandler<NucleusMailContent>): void {
    this.delegate.getMailContent(emailRequestId, handler as any);
  }

  getMailSteps(emailRequestId: string, handler: ServiceHandler<NucleusMailStepResult[]>): void {
    this.delegate.getMailSteps(emailRequestId, handler as any);
  }

  resendEmail(handler: ServiceHandler<void>, emailRequestId: string): void {
    this.delegate.resendEmail(handler, emailRequestId);
  }

  getPDFReport(handler: ServiceHandler<Blob>, filter: NucleusMailFilter, page?: Page): void {
    this.delegate.getPDFReport(handler, this.toRequest(filter, page));
  }

  getXLSReport(handler: ServiceHandler<Blob>, filter: NucleusMailFilter, page?: Page): void {
    this.delegate.getXLSReport(handler, this.toRequest(filter, page));
  }

  getCSVReport(handler: ServiceHandler<Blob>, filter: NucleusMailFilter, page?: Page): void {
    this.delegate.getCSVReport(handler, this.toRequest(filter, page));
  }

  private toRequest(filter: NucleusMailFilter, page?: Page): FilterRequest<NucleusMailFilter> {
    const req = new FilterRequest<NucleusMailFilter>(filter);
    if (page) { req.page = page; }
    return req;
  }
}
